import { defineStore } from 'pinia'

export const useSmartlistStore = defineStore('smartlist', {
  state: () => {
    return {
      currentFormDisplayed: Cookies.get('smartlistCurrentFormDisplayed') || 'none',
    }
  },
  actions: {

    toggleFiltersForm() {
      this.currentFormDisplayed = (this.currentFormDisplayed === 'filters') ? 'none' : 'filters';
      Cookies.set('smartlistCurrentFormDisplayed', this.currentFormDisplayed, { expires: 30 });
    },

    showFiltersForm() {
      this.currentFormDisplayed = 'filters';
      Cookies.set('smartlistCurrentFormDisplayed', this.currentFormDisplayed, { expires: 30 });
    },

    hideHeaderForms() {
      this.currentFormDisplayed = 'none';
      Cookies.set('citizensCurrentFormDisplayed', this.currentFormDisplayed, { expires: 30 });
    },

  }
})
